export const validImageContentTypes = ["image/jpeg", "image/png", "image/gif"]; // Corresponding constants are also in: Z-Apps\Util\ImageUtil.cs

export function validateImage(file: File) {
    if (!validImageContentTypes.includes(file.type)) {
        return "Sorry, only JPG, JPEG, PNG & GIF files are allowed";
    }

    if (file.size > 10000000) {
        return "File size must be less than 10MB";
    }
    return null;
}
